export function getSignInUrl(webUrl: string): string {
	return `${webUrl}/users/sign-in`;
}
